import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const MasterListReportRedux = createActions(
  {
    MasterListReportRequest: ['start_date', 'end_date'],
    MasterListReportSuccess: ['data', 'fileName'],
    MasterListReportError: ['error'],
    CentersMasterListReportRequest: ['start_date', 'end_date', 'centerId'],
    CentersMasterListReportSuccess: ['data', 'fileName'],
    CentersMasterListReportError: ['error'],
  },
  {
    prefix: 'MASTERLISTREPORT_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = MasterListReportRedux
export const MasterListReportTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  sending: {
    fetching: false,
    error: null,
  },
}, {
  get: true,
})

/* ------------- Reducers ------------- */

const MasterListReportRequest = state => state.merge({ sending: { fetching: true, error: null } }, d)

const MasterListReportSuccess = (state, { data, fileName }) => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
  data: { file: data, fileName }
}, d)
const MasterListReportError = (state, { error }) =>
  state.merge({ sending: { fetching: false, error } }, d)

const CentersMasterListReportRequest = state => state.merge({ sending: { fetching: true, error: null } }, d)

const CentersMasterListReportSuccess = (state, { data, fileName }) => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
  data: { file: data, fileName }
}, d)
const CentersMasterListReportError = (state, { error }) =>
  state.merge({ sending: { fetching: false, error } }, d)


export const reducer = createReducer(
  INITIAL_STATE, {
    [Types.MasterListReportRequest]: MasterListReportRequest,
    [Types.MasterListReportSuccess]: MasterListReportSuccess,
    [Types.MasterListReportError]: MasterListReportError,
    [Types.CentersMasterListReportRequest]: CentersMasterListReportRequest,
    [Types.CentersMasterListReportSuccess]: CentersMasterListReportSuccess,
    [Types.CentersMasterListReportError]: CentersMasterListReportError,
  },
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/MasterListReportRedux.js